const selectorsNewsletter = {
  form: 'form',
  ICON_LOADING_EL: '.js-newsletter-icon-loading',
  VALIDATE_FORM_SELECTOR: 'custom-validate-form',
  SUBMIT_BUTTON_SELECTOR: 'button[type="submit"]',
  NOTICE_SUCCESS: '.js-notice-success-footer',
  NOTICE_ERROR: '.js-notice-error-footer',
  ACTIVE_CLASS: 'active',
  NOTICE_MESSAGE: '.notice__message',
  DATA_TIME_CLOSE_NOTICE: 'data-auto-close'
}

const configNewsletterFooter = window.newsletterFooterConfig

class NewsletterFooter extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector(selectorsNewsletter.form)
    this.validateForm = this.querySelector(selectorsNewsletter.VALIDATE_FORM_SELECTOR)
    this.buttonSubmit = this.querySelector(selectorsNewsletter.SUBMIT_BUTTON_SELECTOR)
    this.noticeSuccess = this.querySelector(selectorsNewsletter.NOTICE_SUCCESS)
    this.noticeError = this.querySelector(selectorsNewsletter.NOTICE_ERROR)
    this.iconLoading = this.querySelector(selectorsNewsletter.ICON_LOADING_EL)
    this.timeCloseNotice = this.getAttribute(selectorsNewsletter.DATA_TIME_CLOSE_NOTICE)
  }

  connectedCallback() {
    this.validate = this.validateForm.initValidate(this.form, true)

    this.validate.onSuccess((event) => {
      event.preventDefault()

      this.onSubmitForm()
    })
  }


  async onSubmitForm() {
    const { email } = Object.fromEntries(new FormData(this.form).entries())

    const url = `${configNewsletterFooter.subscriptionUrl}?company_id=${configNewsletterFooter.publicKey}`
    const options = {
      method: 'POST',
      headers: { revision: '2026-04-15', 'content-type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: configNewsletterFooter.listId } } }
        }
      })
    }

    this.isAdding(true)
    try {
      const response = await fetch(url, options)

      if (response.status === 202) {
        this.showMessage()
      } else {
        this.showMessage('error', 'The subscription list was unsuccessful')
      }
    } catch (error) {
      this.showMessage('error', `The subscription marketing list was unsuccessful due to an error: ${error}`)
    }
    this.form.reset()
    this.isAdding(false)
  }

  showMessage(type = 'success', message) {
    if (!this.noticeSuccess && !this.noticeError) {
      return
    }

    if (type === 'success') {
      if (message) {
        const noticeMessageEl = this.noticeSuccess.querySelector(selectorsNewsletter.NOTICE_MESSAGE)

        noticeMessageEl.innerHTML = message
      }
      this.noticeSuccess.classList.add(selectorsNewsletter.ACTIVE_CLASS)
      this.hideNotice(this.noticeSuccess)
    } else {
      if (message) {
        const noticeMessageEl = this.noticeError.querySelector(selectorsNewsletter.NOTICE_MESSAGE)

        noticeMessageEl.innerHTML = message
        this.noticeError.classList.add(selectorsNewsletter.ACTIVE_CLASS)
        this.hideNotice(this.noticeError)
      }
    }
  }

  isAdding(status) {
    if (!this.iconLoading) {
      return
    }

    if (status) {
      this.iconLoading.classList.add(selectorsNewsletter.ACTIVE_CLASS)
    } else {
      this.iconLoading.classList.remove(selectorsNewsletter.ACTIVE_CLASS)
    }
  }

  hideNotice(el) {
    setTimeout(() => {
      el.classList.remove(selectorsNewsletter.ACTIVE_CLASS)
    }, this.timeCloseNotice)
  }
}

if (!customElements.get('newletter-footer')) {
  customElements.define('newletter-footer', NewsletterFooter)
}

